<template>
  <div class="detail__model" v-if="!loading && modelDetail">
    <div class="content__selector form" v-for="(attribute, index) in mainAttributes" :key="index">
      <div class="form-group selectbox" :class="{ '-error': error && !selectedMainAttributes[index].attribute }">
        <div class="input">
          <select :name="attribute.title" :id="attribute.title" class="-filled" v-model="selectedMainAttributes[index]"
            @change="changeMainAttribute()">
            <option :value="{ mainAttribute: attribute.title, attribute: null }">{{ $t('form.select.placeholder') }}
            </option>
            <option v-for="item in attribute.items" :key="item.uid"
              :value="{ mainAttribute: attribute.title, attribute: item.uid }"
              :disabled="isInPossibleCombinations(attribute.title, item.uid)">{{ item.title }}</option>
          </select>
          <div class="input-background">
            <label class="control-label" for="variants">{{ attribute.title }}</label>
          </div>
        </div>
        <div class="help-block error" v-if="error && !selectedMainAttributes[index].attribute">
          <span>{{ $t('error.required') }}</span>
        </div>
      </div>
    </div>
    <div class="content__piece form">
      <div class="form-group">
        <div class="input ">
          <input type="number" name="piece" id="piece" min="1" class="-filled" v-model="quantity">
          <div class="input-background">
            <label for="piece" class="control-label">{{ $t('form.input.label') }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="content__detail">
      <div class="detail__info">
        <span class="heading delta">{{ modelDetail.id }}</span>
        <div class="bold">{{ $t('labels.model') }}</div>
      </div>
      <div class="detail__info">
        <span class="heading delta">{{ modelDetail.product.groupId }}</span>
        <div class="bold">{{ $t('labels.productGroup') }}</div>
      </div>
      <div class="detail__info" v-if="currentVariant">
        <span class="heading delta">{{ currentVariant.id }}</span>
        <div class="bold">{{ $t('labels.articleNumber') }}</div>
      </div>
    </div>
    <div v-if="currentVariant && currentVariant.technicalNote" class="tech__wrapper">
      <span class="bold">{{ $t('labels.technicalNote') }}: &nbsp;</span><span>{{ currentVariant.technicalNote }}</span>
    </div>
    <div class="attributes__container">
      <div class="attribute__container" v-for="(attribute, index) in attributes" :key="index">
        <span class="bold">{{ attribute.title }}</span>
        <div class="container__content">
          <div v-for="item in attribute.items" :key="item.uid" class="content__card">
            <div class="card__item">
              <div class="item__icon" v-if="item.icon">
                <img :src="item.icon.split('|')[0]" :alt="item.icon.split('|')[1]" :title="item.icon.split('|')[2]" />
              </div>
              <div class="item__title">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons__container">
      <div class="btn -btn-accent-inverted-alpha"
        :class="watchlistBtn ? 'icon-mark-check-before -active' : 'icon-mark-before'" @click="watchlistButton()">
        <span v-show="!watchlistBtn">{{ $t('buttons.watchlistAdd') }}</span>
        <span v-show="watchlistBtn">{{ $t('buttons.watchlistAdded') }}</span>
      </div>
      <a class="btn -btn-accent-inverted icon-email-before model-detail-form" @click="openFormModal()">{{
        $t('buttons.email') }}</a>
    </div>
  </div>
  <div class="detail__model -loading" v-else>
    <div class="content__selector"></div>
    <div class="content__detail">
      <div v-for="item in 3" :key="`loading-${item}`" class="detail__info">
        <div class="loading-line line-one"></div>
        <div class="loading-line line-two"></div>
      </div>
    </div>
    <div class="attributes__container">
      <div v-for="item in 2" :key="`loading-${item}`" class="attribute__container">
        <div class="loading-line"></div>
        <div class="container__content">
          <div v-for="content in 4" :key="`loading-${content}`" class="content__card">
            <div class="card__item"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      modelDetail: null,
      variants: [],
      mainAttributes: [],
      selectedMainAttributes: [],
      apiBase: window.app.model_detail.api_base,
      selectedModelUid: window.app.model_detail.selectedModelUid,
      selectValue: null,
      loading: false,
      watchlistBtn: false,
      quantity: 1,
      error: false
    }
  },
  computed: {
    currentVariant () {
      return this.variants.find((variant) => variant.uid === this.selectValue)
    },
    attributes () {
      const attributes = []
      if (this.currentVariant) {
        const variantAttributes = Object.values(this.currentVariant.attributes)
        variantAttributes.forEach(attribute => {
          if (attribute.type.type === 'tag' && !attributes.some(item => item.title === attribute.type.titleModelpage)) {
            attributes.push({ title: attribute.type.titleModelpage, items: [] })
          }
        })
        attributes.forEach(attribute => {
          attribute.items = variantAttributes.filter(item => item.type.titleModelpage === attribute.title)
        })
      }
      return attributes
    }
  },
  methods: {
    getModelDetail () {
      this.loading = true
      Axios.get(this.apiBase + 'model/' + this.selectedModelUid + '/')
        .then((response) => {
          this.modelDetail = response.data
          this.variants = Object.values(response.data.variants)
          const attributes = []
          this.variants.forEach(variant => {
            const variantAttributes = Object.values(variant.attributes)
            variantAttributes.forEach(attribute => {
              if (attribute.type.type === 'main' && !attributes.some(item => item.title === attribute.type.titleModelpage)) {
                attributes.push({ title: attribute.type.titleModelpage, items: [] })
              }
              const key = attributes.findIndex(value => value.title === attribute.type.titleModelpage)
              if (key >= 0 && !attributes[key].items.some(value => value.uid === attribute.uid)) {
                attributes[key].items.push(structuredClone(attribute))
              }
            })
          })
          this.mainAttributes = attributes
          if (this.currentVariant) {
            this.selectedMainAttributes = Object.values(this.currentVariant.attributes)
              .filter(attribute => this.mainAttributes.some(mainAttribute => mainAttribute.title === attribute.type.titleModelpage))
              .sort((a, b) => this.mainAttributes.findIndex(attribute => attribute.title === a.type.titleModelpage) - this.mainAttributes.findIndex(attribute => attribute.title === b.type.titleModelpage))
              .map(attribute => ({ mainAttribute: attribute.type.titleModelpage, attribute: attribute.uid }))
          } else {
            this.selectedMainAttributes = this.mainAttributes.map(mainAttribute => ({ mainAttribute: mainAttribute.title, attribute: null }))
          }
          this.loading = false
          this.checkButtonStatus()
        })
    },
    replaceState () {
      const url = new URL(window.location.href)
      // Delete all existing params
      for (const key of url.searchParams.keys()) {
        url.searchParams.delete(key)
      }
      // Add all params
      if (this.selectValue) {
        url.searchParams.set('variant', this.selectValue)
      }
      window.history.replaceState({}, '', url)
    },
    watchlistButton () {
      if (this.selectValue) {
        this.watchlistBtn = !this.watchlistBtn
        // add the uid of the model to localStorage or remove it
        if (this.watchlistBtn) {
          const watchlist = JSON.parse(localStorage.getItem('watchlist')) || []
          watchlist.push('m' + this.modelDetail?.uid + 'v' + this.selectValue + 'i' + this.currentVariant?.id + 'p' + (this.quantity > 1 ? this.quantity : 1))
          localStorage.setItem('watchlist', JSON.stringify(watchlist))
        } else {
          const watchlist = JSON.parse(localStorage.getItem('watchlist')) || []
          // find the index in the watchlist array and then remove it
          const index = watchlist.findIndex(item => item.includes('m' + this.modelDetail?.uid + 'v' + this.selectValue + 'i' + this.currentVariant?.id))
          watchlist.splice(index, 1)
          localStorage.setItem('watchlist', JSON.stringify(watchlist))
        }
        var evt = new CustomEvent('storagechange')
        window.dispatchEvent(evt)
      } else {
        this.error = true
      }
    },
    checkButtonStatus () {
      const watchlist = JSON.parse(localStorage.getItem('watchlist')) || []
      let found = false
      watchlist.forEach((item) => {
        if (item.includes('m' + this.modelDetail?.uid + 'v' + this.selectValue + 'i' + this.currentVariant?.id)) {
          found = true
        }
      })
      this.watchlistBtn = found
    },
    openFormModal () {
      if (this.selectValue) {
        if (!this.watchlistBtn) {
          this.watchlistButton()
        }
        const evt = new CustomEvent('openFormModal')
        window.dispatchEvent(evt)
      } else {
        this.error = true
      }
    },
    changeMainAttribute () {
      const matchedVariants = this.variants.filter(variant => {
        let matchAllMainAttributes = true
        if (this.mainAttributes.length !== this.selectedMainAttributes.length) {
          matchAllMainAttributes = false
        } else {
          this.selectedMainAttributes.forEach(selected => {
            if (!selected.attribute || !Object.values(variant.attributes).some(variantAttribute => variantAttribute.uid === selected.attribute)) {
              matchAllMainAttributes = false
            }
          })
        }
        return matchAllMainAttributes
      })
      if (matchedVariants.length) {
        this.selectValue = matchedVariants[0].uid
      } else {
        this.selectValue = null
      }
      this.replaceState()
    },
    isInPossibleCombinations (mainAttribute, attributeValue) {
      const otherSelectedMainAttributes = this.selectedMainAttributes.filter(selected => selected.mainAttribute !== mainAttribute)
      const variantsWithOtherMainAttributes = this.variants.filter(variant => {
        let matchAllOtherMainAttributes = true
        otherSelectedMainAttributes.forEach(selected => {
          if (selected.attribute && !Object.values(variant.attributes).some(variantAttribute => variantAttribute.uid === selected.attribute)) {
            matchAllOtherMainAttributes = false
          }
        })
        return matchAllOtherMainAttributes
      })
      return !(variantsWithOtherMainAttributes.length && variantsWithOtherMainAttributes.some(variant => Object.values(variant.attributes).some(variantAttribute => variantAttribute.type.titleModelpage === mainAttribute && variantAttribute.uid === attributeValue)))
    }
  },
  watch: {
    selectValue: function () {
      this.checkButtonStatus()
    },
  },
  created () {
    const url = new URL(window.location.href)
    if (url.searchParams.has('variant')) {
      this.selectValue = parseInt(url.searchParams.get('variant'))
    }
  },
  mounted () {
    this.getModelDetail()
    window.addEventListener('storageDeleted', () => {
      this.checkButtonStatus()
    })
  },

}

</script>
